export enum INNActionType {
    SetHiddenOrgName = "SET_HIDDEN_ORG_NAME",
}

export interface INNAction {
    type: INNActionType.SetHiddenOrgName;
    payload: boolean;
}

export function setHiddenOrgName(isHidden: boolean): INNAction {
    return {
        type: INNActionType.SetHiddenOrgName,
        payload: isHidden,
    };
}
